import { MapContainer, TileLayer, Marker, Polyline, Popup, useMap  } from 'react-leaflet';
import L, { LatLngExpression, LatLngBoundsExpression } from 'leaflet';
import {TripDay } from '../types';
import { useEffect } from 'react';



type MapProps = {
    tripDays: TripDay[];
    selectedDay?: TripDay; // ajout
    height?: string;
  };
  
  // Composant pour ajuster les bounds
  const FitBounds = ({ positions }: { positions: LatLngExpression[] }) => {
    const map = useMap();
  
    useEffect(() => {
      const bounds = L.latLngBounds(positions);
      map.fitBounds(bounds, { padding: [30, 30] });
    }, [map, positions]);
  
    return null;
  };
  
  export default function MapItinerary({ tripDays, selectedDay, height = '200px' }: MapProps) {
    const positions = tripDays.map(day => day.coordinates);
  
    return (
      <MapContainer
        center={positions[0]}
        zoom={7}
        scrollWheelZoom={false}
        style={{ height: height, width: '100%' }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
  
        <FitBounds positions={positions} />
  
        {tripDays.map((day, idx) => (
          <Marker key={day.id} position={day.coordinates}>
            <Popup>
              <strong>{day.title}</strong><br />
              {day.description}
            </Popup>
          </Marker>
        ))}
        <MapEffect selectedDay={selectedDay} />
        <Polyline positions={positions} color="blue" />
      </MapContainer>
    );
  }

function MapEffect({ selectedDay }: { selectedDay?: TripDay }) {
  const map = useMap();

  useEffect(() => {
    if (selectedDay) {
      map.flyTo(selectedDay.coordinates, 12, { duration: 1.2 });
    }
  }, [selectedDay, map]);

  return null;
}